import AxiosInstance, { ACCOUNT_HEADER_KEY, AUTH_HEADER_KEY, SPACE_HEADER_KEY } from "../utils/axios.js"

/*****  Auth Starts  *****/
export const authStore = async ({ shop, code, scope, host }) => {
    return AxiosInstance.get(`/auth/auth-store?shop=${shop}&code=${code}&scope=${scope}&host=${host}`)
}

export const getUser = async (token) => {
    return AxiosInstance.get('/auth/user', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getUserAccountsByJwt = async (token) => {
    return AxiosInstance.get('/auth/user/account', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getSpacesByJwt = async (token) => {
    return AxiosInstance.get('/auth/user/space', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getSpacesOfUser = async (token) => {
    return AxiosInstance.get('/auth/space', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const inviteUserToAccount = async ({ emailToInvite, urlToAcceptInvitation, role }) => {
    return AxiosInstance.post('/auth/account/user/invite', { emailToInvite, urlToAcceptInvitation, role })
}

export const getInvitationData = async (inviteeToken) => {
    return AxiosInstance.get(`/auth/user/invitation?inviteeToken=${inviteeToken}`)
}

export const registerUser = async (userData) => {
    return AxiosInstance.post('/auth/user', userData)
}

export const logInUser = async ({ email, password }) => {
    return AxiosInstance.post('/auth/user/login', { email, password })
}

export const acceptInvitation = async ({ inviteeToken, userId }) => {
    return AxiosInstance.post('/auth/user/accept-invitation', { inviteeToken, userId })
}

export const authUser = async ({ email, password, name, utmData, profileImage, authProvider, authProviderData }) => {
    return AxiosInstance.post('/auth/user/register', { email, password, name, utmData, profileImage, authProvider, authProviderData })
}

export const updateUser = async (userId, { email, name, profileImage, featureDiscovery }) => {
    return AxiosInstance.put(`/auth/user/${userId}`, { email, name, profileImage, featureDiscovery })
}

export const completeFeatureDiscovery = async (featureKey) => {
    return AxiosInstance.post('/auth/user/feature-discovery', { featureKey })
}

export const updateUserPassword = async ({ userId, oldPassword, newPassword }) => {
    return AxiosInstance.post('/auth/user/password', { userId, oldPassword, newPassword })
}

export const updateAccount = async (accountId, { name, email, users, shouldInitializeResearch, mainWebsite, requiresOnboarding }) => {
    return AxiosInstance.put(`/auth/account/${accountId}`, { name, email, users, shouldInitializeResearch, mainWebsite, requiresOnboarding })
}

export const updateSpace = async (spaceId, spaceData) => {
    return AxiosInstance.put(`/auth/space/${spaceId}`, spaceData)
}

export const getSpaceUsers = async (spaceId) => {
    return AxiosInstance.get(`/auth/space/users?spaceId=${spaceId}`)
}

export const createSpace = async (spaceData) => {
    return AxiosInstance.post('/auth/space', spaceData)
}

export const deleteSpace = async (spaceId) => {
    return AxiosInstance.delete(`/auth/space/${spaceId}`)
}

export const deleteSpaceMember = async (spaceId, userId) => {
    return AxiosInstance.delete(`/auth/space/${spaceId}/user/${userId}`)
}

export const assignUserToSpace = async (spaceId, userData) => {
    return AxiosInstance.post(`/auth/space/${spaceId}/user`, userData)
}

export const removeUserFromSpace = async (spaceId, userData) => {
    return AxiosInstance.post(`/auth/space/${spaceId}/user/remove`, userData)
}

export const getAccountUsers = async () => {
    return AxiosInstance.get(`/auth/account/users`)
}

export const removeUserFromAccount = async (userData) => {
    return AxiosInstance.post(`/auth/account/user/remove`, userData)
}

export const googleAuth = async (data) => {
    return AxiosInstance.post(`/auth/providers/google`, data)
}

// userId, oldPassword, newPassword
/*****  Auth Ends  *****/


/*****  MCP OAuth Starts  *****/
// These live on the MCP service at the monolith root (no /brain-style service
// prefix) — see spring-backend Task 1-3 of the MCP OAuth plan.
export const getMcpOauthRequest = async (requestId) => {
    return AxiosInstance.get(`/mcp/oauth/request/${requestId}`)
}

export const approveMcpOauthRequest = async ({ requestId, spaceIds }) => {
    return AxiosInstance.post('/mcp/oauth/approve', { requestId, spaceIds })
}

export const denyMcpOauthRequest = async ({ requestId }) => {
    return AxiosInstance.post('/mcp/oauth/deny', { requestId })
}

export const saveMcpDiscovery = async ({ requestId, answers, clientName }) => {
    return AxiosInstance.post('/mcp/oauth/discovery', { requestId, answers, clientName })
}
/*****  MCP OAuth Ends  *****/


/*****  EconProvider Starts  *****/
export const searchProductsByTitle = async (title) => {
    return AxiosInstance.get(`/ecom-provider/products/search?title=${title}`)
}
/*****  EconProvider Ends  *****/


/*****  Integrations Starts  *****/
export const connectToKlaviyo = async (authData, accountId) => {
    return AxiosInstance.post(`/integrations/klaviyo/connect`, authData, { headers: { [ACCOUNT_HEADER_KEY]: accountId } })
}

export const connectToTikTok = async (authData) => {
    return AxiosInstance.post(`/integrations/tiktok/connect`, authData)
}

export const connectToLinkedIn = async (authData) => {
    return AxiosInstance.post(`/integrations/linkedin/connect`, authData)
}

export const connectToAxon = async (authData) => {
    return AxiosInstance.post(`/integrations/axon/connect`, authData)
}

export const connectToTripleWhale = async (authData) => {
    return AxiosInstance.post(`/integrations/triplewhale/connect`, authData)
}

export const connectToNorthbeam = async (data) => {
    // data = { apiKey, clientId, name }
    return AxiosInstance.post(`/integrations/northbeam/connect`, data)
}

export const generateAnalyticsSourceReport = async (integration, data) => {
    // data = { channel, sinceDate, untilDate, adIds, providerAccountId } - providerAccountId scopes
    // the report to the space's source ad account, since one integration can span multiple shops
    return AxiosInstance.post(`/integrations/unified/analytics-report?integrationId=${integration}`, data)
}

export const generateKlaviyoCodes = async () => {
    return AxiosInstance.get('/integrations/klaviyo/codes')
}

export const finishMetaOauthFlow = async (integrationData) => {
    return AxiosInstance.post('/integrations/meta/connect', integrationData)
}

export const generateTikTokReport = async (integration, { advertiserId, startDate, endDate }) => {
    return AxiosInstance.post(`/integrations/tiktok/ads-report?integrationId=${integration}`, { advertiserId, startDate, endDate })
}

export const generateUnifiedAdsReport = async (integration, data) => {
    // data = { advertiserId, sinceDate, untilDate, providerAccountId, filters, breakdowns, daysToSplitIncrement, ignoreCache }
    return AxiosInstance.post(`/integrations/unified/ads-report?integrationId=${integration}`, data)
}

export const generateUnifiedAdsReportByIds = async (integration, data) => {
    // data = { advertiserId, sinceDate, untilDate, providerAccountId, filters, breakdowns, daysToSplitIncrement, ignoreCache, adIds }
    return AxiosInstance.post(`/integrations/unified/ads-report-by-ids?integrationId=${integration}`, data)
}

export const syncAdAccounts = async (integration) => {
    return AxiosInstance.post(`/integrations/unified/sync-ad-accounts?integrationId=${integration}`)
}

export const triggerUnifiedSyncAdAccountData = async (integration, providerAccountId) => {
    return AxiosInstance.post(`integrations/unified/trigger-sync-ad-account-data?integrationId=${integration}`, { providerAccountId })
}

export const generateUnifiedCampaignInsightsReport = async (integration, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, adIds }) => {
    return AxiosInstance.post(`/integrations/unified/campaign-report?integration=${integration}`, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, adIds })
}

// Lean per-ad filter fields (name / status / campaign / ad set) for views account-widget filters. Meta only.
export const generateUnifiedAdFilterFieldsReport = async (integration, { providerAccountId, sinceDate, untilDate }) => {
    return AxiosInstance.post(`/integrations/unified/ad-filter-fields?integration=${integration}`, { providerAccountId, sinceDate, untilDate })
}

export const generateUnifiedAccountInsightsReport = async (integration, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, adIds }) => {
    return AxiosInstance.post(`/integrations/unified/account-report?integration=${integration}`, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, adIds })
}

// Ads level - what we use for all the creative analytics reports
export const generateMetaReport = async (integration, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, ignoreCache }) => {
    return AxiosInstance.post(`/integrations/meta/ads-report-insights?integration=${integration}`, { providerAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement, ignoreCache })
}

// Account level - what we use for the account overview page
export const generateMetaAccountInsightsReport = async (integration, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement }) => {
    return AxiosInstance.post(`/integrations/meta/account-insights?integration=${integration}`, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement })
}

export const generateMetaAccountCampaignInsightsReport = async (integration, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement }) => {
    return AxiosInstance.post(`/integrations/meta/campaign-insights?integration=${integration}`, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement })
}

export const getAccountOverviewSettings = async () => {
    return AxiosInstance.get(`/creative/account-overview-settings`)
}

export const updateAccountOverviewSettings = async (settings) => {
    return AxiosInstance.post(`/creative/account-overview-settings`, settings)
}

export const getMetaAdInsights = async ({ integration, adId, sinceDate, untilDate, breakdownType, daysToSplitIncrement }) => {
    let url = `/integrations/meta/ad-insights?integration=${integration}&adId=${adId}`
    if (sinceDate) {
        url += `&sinceDate=${sinceDate}`
    }
    if (untilDate) {
        url += `&untilDate=${untilDate}`
    }
    if (breakdownType) {
        url += `&breakdownType=${breakdownType}`
    }

    if (daysToSplitIncrement) {
        url += `&daysToSplitIncrement=${daysToSplitIncrement}`
    }

    return AxiosInstance.get(url)
}

export const getMetaSyncJobs = async () => {
    return AxiosInstance.get(`/integrations/jobs`)
}

export const triggerMetaSyncJob = async (integration, adAccountId) => {
    return AxiosInstance.post(`/integrations/meta/trigger-sync-ad-account-data?integration=${integration}&adAccountId=${adAccountId}`)
}

export const updateIntegration = async (integrationId, integrationData) => {
    return AxiosInstance.put(`/integrations/${integrationId}`, integrationData)
}

export const checkFb = async (data) => {
    return AxiosInstance.post(`/integrations/check-fb`, data)
}

export const getIntegrations = async () => {
    return AxiosInstance.get('/integrations/all')
}

export const getKlaviyoTemplateById = async (templateId, integration) => {
    return AxiosInstance.get(`/integrations/klaviyo/template/${templateId}?integration=${integration}`)
}

export const updateKlaviyoTemplateById = async (templateId, templateData) => {
    return AxiosInstance.put(`/integrations/klaviyo/template/${templateId}`, templateData)
}

export const createKlaviyoTemplate = async (templateData) => {
    return AxiosInstance.post(`integrations/klaviyo/template`, templateData)
}

export const createKlaviyoCampaign = async (campaignData, integration) => {
    return AxiosInstance.post(`integrations/klaviyo/campaign/full-flow?integration=${integration}`, campaignData)
}

export const updateKlaviyoCampaign = async (campaignData, campaignId, integration) => {
    return AxiosInstance.put(`integrations/klaviyo/campaign/${campaignId}/full-flow?integration=${integration}`, campaignData)
}

export const getKlaviyoCustomerLists = async (integration) => {
    return AxiosInstance.get(`integrations/klaviyo/list?integration=${integration}`)
}

export const getKlaviyoAccounts = async (integration) => {
    return AxiosInstance.get(`integrations/klaviyo/accounts?integration=${integration}`)
}

export const deleteKlaviyoCampaign = async (integration, campaignId) => {
    return AxiosInstance.delete(`/integrations/klaviyo/campaign/${campaignId}?integration=${integration}`)
}

export const updateKlaviyoSendJob = async (integration, sendJobId) => {
    return AxiosInstance.put(`integrations/klaviyo/campaign/send-job/${sendJobId}?integration=${integration}`)
}

export const connectShopify = async (authData, accountId, jwt) => {
    return AxiosInstance.post(`/integrations/shopify/connect`, authData, { headers: { [ACCOUNT_HEADER_KEY]: accountId, [AUTH_HEADER_KEY]: jwt } })
}

export const getAccountByShopifyDomain = async (shopDomain) => {
    return AxiosInstance.get(`/integrations/shopify/account?shopDomain=${shopDomain}`)
}

export const getStoreCompetitors = async (integrationId, ignoreCache) => {
    let url = `/integrations/shopify/competitors?integrationId=${integrationId}`
    if (ignoreCache) {
        url += `&ignoreCache=${ignoreCache}`
    }
    return AxiosInstance.get(url)
}

export const getShopifyProducts = async (title) => {
    let url = `/integrations/shopify/products`
    if (title) {
        url += `?title=${title}`
    }
    return AxiosInstance.get(url)
}

export const syncMetaAdAccounts = async (integration) => {
    return AxiosInstance.post(`/integrations/meta/sync-ad-accounts?integration=${integration}`)
}

/*****  Integrations Ends  *****/

/***** Creative Starts *****/
export const getCreatives = async (addAccountId) => {
    let url = '/creative'
    if (addAccountId) {
        url += `?adAccountId=${addAccountId}`
    }
    return AxiosInstance.get(url)
}

export const getManyCreativesById = async (creativeIds) => {
    return AxiosInstance.post('/creatives/many', { creativeIds })
}

export const getCreativeAsyncAnalyzeJobStatus = async () => {
    return AxiosInstance.get(`/creative/async-analyze/status`)
}

export const getCreativeById = async (creativeId) => {
    return AxiosInstance.get(`/creative/${creativeId}`)
}

export const getCreativeComments = async ({ integrationId, adId, limit = 100 }) => {
    return AxiosInstance.get('/integrations/unified/creative-comments', { params: { integrationId, adId, limit } })
}

export const getCommentsSummary = async ({ creativeId, adId, integrationId }) => {
    return AxiosInstance.get(`/creative/${creativeId}/comments/summary`, { params: { adId, integrationId } })
}

export const generateTranscript = async ({ creativeId, regenerate = false }) => {
    return AxiosInstance.post(`/creative/${creativeId}/transcript`, { regenerate })
}



export const generateCreativeDownloadLink = async (creativeId, fileName) => {
    const params = new URLSearchParams({ creativeId })
    if (fileName) {
        params.set('fileName', fileName)
    }
    return AxiosInstance.get(`/creative/download-link?${params.toString()}`)
}

export const generateExternalAdDownloadLink = async (externalAdId) => {
    return AxiosInstance.get(`/creative/external-ad/download-link?externalAdId=${externalAdId}`)
}

export const generateExternalAdDownloadLinkPublic = async (externalAdId) => {
    return AxiosInstance.get(`/creative/external-ad/download-link/public?externalAdId=${externalAdId}`)
}

export const getFolders = async () => {
    return AxiosInstance.get('creative/folder')
}

export const createFolder = async (folderData) => {
    return AxiosInstance.post('creative/folder', folderData)
}

export const deleteFolder = async (folderId) => {
    return AxiosInstance.delete(`/creative/folder/${folderId}`)
}

export const updateFolder = async (folderId, folderData) => {
    return AxiosInstance.put(`/creative/folder/${folderId}`, folderData)
}

export const deleteCreative = async (creativeId) => {
    return AxiosInstance.delete(`creative/${creativeId}`)
}

export const updateCreatives = async (creativeId, creativeData) => {
    return AxiosInstance.put(`creative/${creativeId}`, creativeData)
}

export const getAdvertisers = async (facebookUrl, advertiserId) => {
    let url = '/creative/advertiser'
    // can't be both
    if (facebookUrl) {
        url += `?facebookUrl=${facebookUrl}`
    }
    if (advertiserId) {
        url += `?advertiserId=${advertiserId}`
    }
    return AxiosInstance.get(url)
}

export const getAdvertiserSuggestions = async () => {
    return AxiosInstance.get(`/creative/advertiser/suggestions`)
}

export const generateExternalAdTranscript = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/generate-transcript`, { externalAdId })
}

export const generateExternalAdStrategicBreakdown = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/generate-breakdown`, { externalAdId })
}

export const generateExternalAdCustomTranscript = async ({ externalAdId, targetEntityName, description }) => {
    return AxiosInstance.post(`/creative/external-ad/generate-custom-transcript`, { externalAdId, targetEntityName, description })
}

export const deleteExternalAdCustomTranscript = async (externalAdId) => {
    return AxiosInstance.delete(`/creative/external-ad/generate-custom-transcript/${externalAdId}`)
}

export const updateExternalAd = async (externalAdId, externalAdData) => {
    return AxiosInstance.put(`/creative/external-ad/${externalAdId}`, externalAdData)
}

export const generateExternalAdCreativeConcept = async ({ externalAdId, userContext }) => {
    return AxiosInstance.post(`/creative/external-ad/generate-concept`, { externalAdId, userContext })
}

export const deleteExternalAdCreativeConcept = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/delete-creative-concept`, { externalAdId })
}

export const getExternalAdCreativeConcept = async (externalAdId) => {
    return AxiosInstance.get(`/creative/external-ad/creative-concept?externalAdId=${externalAdId}`)
}

export const getAdvertiserAds = async (advertiserId, allowClusterInstances = false) => {

    let url = `creative/advertiser/ads?advertiserId=${advertiserId}`
    if (allowClusterInstances) {
        url += `&allowClusterInstances=true`
    }

    return AxiosInstance.get(url)
}

export const followAdvertiser = async (advertiserId) => {
    return AxiosInstance.post(`creative/advertiser-space`, { advertiserId })
}

export const followAdvertiserWithSpace = async (advertiserId, spaceId) => {
    return AxiosInstance.post(`creative/advertiser-space`, { advertiserId }, { headers: { [SPACE_HEADER_KEY]: spaceId } })
}

export const unfollowAdvertiser = async (advertiserId) => {
    return AxiosInstance.post(`creative/remove-advertiser-space?advertiserId=${advertiserId}`)
}

export const analyzeAdvertiserCreativeStrategy = async (advertiserId, ignoreCache) => {
    return AxiosInstance.post(`creative/advertiser/analyze-strategy`, { advertiserId, ignoreCache })
}

export const analyzeAdvertiserCreativeStrategyCustomQuery = async (advertiserId, query) => {
    return AxiosInstance.post(`creative/advertiser/analyze-strategy-custom-query`, { advertiserId, query })
}

export const generateBrandStrategySnapshot = async (data) => {
    return AxiosInstance.post(`/creative/brand/strategy/snapshot`, data)
}

export const getBrandStrategySnapshot = async (snapshotId) => {
    return AxiosInstance.get(`/creative/brand/strategy/snapshot/${snapshotId}`)
}

export const getCreativeReports = async () => {
    return AxiosInstance.get('creative/report')
}

export const createCreativeReport = async (createReportData) => {
    return AxiosInstance.post('creative/report', createReportData)
}

export const updateCreativeReport = async (reportId, createReportData) => {
    return AxiosInstance.put(`creative/report/${reportId}`, createReportData)
}

export const deleteCreativeReport = async (reportId) => {
    return AxiosInstance.delete(`creative/report/${reportId}`)
}

export const generateSnapshot = async (snapshotData) => {
    return AxiosInstance.post(`/creative/snapshot`, snapshotData)
}

export const getPublicSnapshot = async (snapshotId) => {
    return AxiosInstance.get(`/creative/snapshot/${snapshotId}`)
}

// ==================== Shareable Reports ====================

export const createShareableReport = async (data) => {
    return AxiosInstance.post('/creative/shareable-report', data)
}

export const getShareableReports = async () => {
    return AxiosInstance.get('/creative/shareable-report')
}

export const updateShareableReport = async (id, data) => {
    return AxiosInstance.put(`/creative/shareable-report/${id}`, data)
}

export const deleteShareableReport = async (id) => {
    return AxiosInstance.delete(`/creative/shareable-report/${id}`)
}

export const authenticateShareableReport = async (id, password) => {
    return AxiosInstance.post(`/creative/shareable-report/${id}/authenticate`, { password })
}

export const getShareableReportSourceData = async (id, token, dates) => {
    const params = {}
    if (dates) {
        params.dates = JSON.stringify(dates)
    }
    return AxiosInstance.get(`/creative/shareable-report/${id}/source-data`, {
        headers: { 'x-share-token': token },
        params,
    })
}

export const getShareableReportData = async (id, token, dates, metrics) => {
    const params = {}
    if (dates) {
        params.dates = JSON.stringify(dates)
    }
    if (metrics) {
        params.metrics = JSON.stringify(metrics)
    }
    return AxiosInstance.get(`/creative/shareable-report/${id}/data`, {
        headers: { 'x-share-token': token },
        params,
    })
}

export const getShareableReportComments = async (id, token) => {
    return AxiosInstance.get(`/creative/shareable-report/${id}/comments`, {
        headers: { 'x-share-token': token },
    })
}

export const addShareableReportComment = async (id, token, commentData) => {
    return AxiosInstance.post(`/creative/shareable-report/${id}/comments`, commentData, {
        headers: { 'x-share-token': token },
    })
}

export const deleteShareableReportComment = async (id, token, commentId) => {
    return AxiosInstance.delete(`/creative/shareable-report/${id}/comments/${commentId}`, {
        headers: { 'x-share-token': token },
    })
}

export const updateCreative = async (creativeId, creativeData) => {
    return AxiosInstance.put(`/creative/${creativeId}`, creativeData)
}

export const analyzeCreative = async (creativeId) => {
    return AxiosInstance.post(`/creative/analyze`, { creativeId })
}

export const getExternalAdForPublicView = async (externalAdId, spaceId) => {
    return AxiosInstance.get(`/creative/external-ad/public/${externalAdId}?spaceId=${spaceId}`)
}

/** Public share view: creative + analysis (no auth). Backend returns { creative } with source/imageUrl, creativeAnalysis, personaAnalysis. */
export const getCreativeSharePublic = async (creativeId, uniqueKey) => {
    return AxiosInstance.get(`/creative/public/creative-insight-sharable/${creativeId}?uniqueKey=${uniqueKey}`)
}

// OLD version (v2) - fetch and generate
export const generateCreativeInsights = async ({ creativeIds, deepDive }) => {
    return AxiosInstance.post(`/creative/creative-insights`, { creativeIds, deepDive })
}

export const suggestSuperSegments = async ({ creativeIds }) => {
    return AxiosInstance.post(`/creative/generate-super-segments`, { creativeIds })
}

export const getExternalAdsForDiscovery = async () => {
    return AxiosInstance.get(`/creative/external-ad/random`)
}

export const searchExternalAds = async (data) => {
    return AxiosInstance.post(`/creative/external-ad/search`, data)
}

export const getManyExternalAdsById = async (externalAdIds) => {
    return AxiosInstance.get(`/creative/external-ad/many-by-id?externalAdIds=${externalAdIds.join(',')}`)
}

export const createBoard = async (boardData) => {
    return AxiosInstance.post(`/creative/external-ad/board`, boardData)
}

export const getBoardsOfSpace = async () => {
    return AxiosInstance.get(`/creative/external-ad/board`)
}

export const getPublicBoardById = async (boardId) => {
    return AxiosInstance.get(`/creative/external-ad/board/public/${boardId}`)
}

export const updateBoard = async ({ boardId, boardData }) => {
    return AxiosInstance.put(`/creative/external-ad/board/${boardId}`, boardData)
}

export const deleteBoard = async ({ boardId }) => {
    return AxiosInstance.delete(`/creative/external-ad/board/${boardId}`)
}

export const semanticSearchCreatives = async ({ creativeIds, query, threshold, minStartOffsetSec, maxEndOffsetSec, ignoreCache }) => {
    return AxiosInstance.post(`/creative/search-by-descriptors-semantic`, { creativeIds, query, threshold, minStartOffsetSec, maxEndOffsetSec, ignoreCache })
}

export const compareSemanticSearchCreatives = async ({ creativeIds, queries, threshold, ignoreCache }) => {
    return AxiosInstance.post(`/creative/search-by-descriptors-semantic-compare`, { creativeIds, queries, threshold, ignoreCache })
}

export const compareCreatives = async ({ targetCreativeId, creativeIdsToCompare, targetAdMetrics, adsToCompareMetrics }) => {
    return AxiosInstance.post(`/creative/creative-comparison`, { targetCreativeId, creativeIdsToCompare, targetAdMetrics, adsToCompareMetrics })
}

// New version (v3) - only fetch
export const getCreativeInsights = async (adAccountId) => {
    return AxiosInstance.get(`/creative/creative-insights?adAccountId=${adAccountId}`)
}

// New version (v3) - generate
export const generateAccountCreativeInsights = async ({ accountId, spaceId, adAccountId, integrationId }) => {
    return AxiosInstance.post(`/creative/agent/generate-insights-cache`, { accountId, spaceId, adAccountId, integrationId })
}

export const getCreativeInsightsByAdGroup = async (adGroupId) => {
    return AxiosInstance.get(`/creative/creative-insights-by-ad-group?adGroupId=${adGroupId}`)
}

export const generateInsightOnDemandPerAd = async ({ adsData, targetAd, question }) => {
    return AxiosInstance.post(`/creative/insights`, { adsData, targetAd, question })
}

export const generateInsightOnDemand = async ({ adsData, question }) => {
    return AxiosInstance.post(`/creative/insights`, { adsData, question })
}

export const getRandomFollowedAdvertiser = async () => {
    return AxiosInstance.get(`/creative/advertiser/random`)
}

export const generateInsightOnDemandWithLLM = async ({ adsData, prompt, context, model }) => {
    return AxiosInstance.post(`/creative/llm-playground`, { adsData, prompt, context, model })
}

export const initialCreativeChat = async (data) => {
    return AxiosInstance.post(`/creative/agent/creative-chat/init`, data)
}

export const creativeChat = async (data) => {
    return AxiosInstance.post(`/creative/agent/creative-chat`, data)
}

export const uploadCreativeAsset = async (data) => {
    return AxiosInstance.post(`/creative/asset/upload`, data)
}

export const signUrlUploadCreativeAsset = async (data) => {
    return AxiosInstance.post(`/creative/asset/sign-url-upload`, data)
}

export const generateAIAnalysisWithinTimeframe = async ({ creativeId, analysisKey, highlightMoments }) => {
    return AxiosInstance.post(`/creative/ai-analysis-within-timeframe`, { creativeId, analysisKey, highlightMoments })
}

export const getAIAnalysisWithinTimeframe = async ({ creativeId, analysisKey }) => {
    return AxiosInstance.get(`/creative/ai-analysis-within-timeframe?creativeId=${creativeId}&analysisKey=${analysisKey}`)
}

// ==================== Views ====================

export const listViews = () => AxiosInstance.get('/views')

export const getView = (viewId) => AxiosInstance.get(`/views/${viewId}`)

export const createView = (payload) => AxiosInstance.post('/views', payload)

export const updateView = (viewId, patch) => AxiosInstance.put(`/views/${viewId}`, patch)

export const patchView = (viewId, patch) => AxiosInstance.patch(`/views/${viewId}`, patch)

export const deleteView = (viewId) => AxiosInstance.delete(`/views/${viewId}`)

export const duplicateView = (viewId) => AxiosInstance.post(`/views/${viewId}/duplicate`)

/***** Creative Ends *****/


/***** Brain Starts *****/

export const initialChat = async (data) => {
    return AxiosInstance.post(`/brain/initiate`, data)
}

export const chat = async (data) => {
    return AxiosInstance.post(`/brain/chat`, data)
}

export const generateAiSummary = async (data) => {
    return AxiosInstance.post(`/brain/single-run/ai-summary`, data)
}

export const generateAiContextBrand = async (data) => {
    return AxiosInstance.post(`/brain/context/brand`, data)
}

export const generateAiContextCalendar = async (data) => {
    return AxiosInstance.post(`/brain/context/calendar`, data)
}

export const generateAiContextPerformanceGoals = async (data) => {
    return AxiosInstance.post(`/brain/context/performance-goals`, data)
}

export const getAiContextBrand = async () => {
    return AxiosInstance.get(`/brain/context/brand`)
}

export const getAiContextCalendar = async () => {
    return AxiosInstance.get(`/brain/context/calendar`)
}

export const getAiContextPerformanceGoals = async () => {
    return AxiosInstance.get(`/brain/context/performance-goals`)
}

export const getChatStatus = async (adAccountId) => {
    return AxiosInstance.get(`/brain/chat/status?adAccountId=${adAccountId}`)
}

export const getUserChats = async (adAccount) => {
    const params = adAccount ? `?adAccount=${adAccount}` : ''
    return AxiosInstance.get(`/brain/chats${params}`)
}

export const getChatMessages = async (chatId) => {
    return AxiosInstance.get(`/brain/chats/${chatId}/messages`)
}

export const loadChat = async (chatId) => {
    return AxiosInstance.post(`/brain/chats/${chatId}/load`)
}

export const updateChat = async (chatId, data) => {
    return AxiosInstance.patch(`/brain/chats/${chatId}`, data)
}

export const deleteChat = async (chatId) => {
    return AxiosInstance.delete(`/brain/chats/${chatId}`)
}

export const getUserProjects = async () => {
    return AxiosInstance.get('/brain/projects')
}

export const createProject = async (data) => {
    return AxiosInstance.post('/brain/projects', data)
}

export const renameProject = async (projectId, data) => {
    return AxiosInstance.patch(`/brain/projects/${projectId}`, data)
}

export const deleteProject = async (projectId) => {
    return AxiosInstance.delete(`/brain/projects/${projectId}`)
}

// Knowledge
export const getAiKnowledge = async () => {
    return AxiosInstance.get('/brain/context/knowledge')
}

export const saveAiKnowledge = async (data) => {
    return AxiosInstance.post('/brain/context/knowledge', data)
}

export const deleteAiKnowledge = async (knowledgeItemId) => {
    return AxiosInstance.delete(`/brain/context/knowledge/${knowledgeItemId}`)
}

// Instructions
export const getAiInstructions = async () => {
    return AxiosInstance.get('/brain/context/instructions')
}

export const saveAiInstruction = async (data) => {
    return AxiosInstance.post('/brain/context/instructions', data)
}

export const deleteAiInstruction = async (instructionItemId) => {
    return AxiosInstance.delete(`/brain/context/instructions/${instructionItemId}`)
}

// Preferences
export const getAiPreferences = async () => {
    return AxiosInstance.get('/brain/context/preferences')
}

export const addAiPreference = async (data) => {
    return AxiosInstance.post('/brain/context/preferences', data)
}

export const deleteAiPreference = async (itemId) => {
    return AxiosInstance.delete(`/brain/context/preferences/${itemId}`)
}

export const createBrainAccountCreativeProfile = async ({ startDate, endDate, adAccount }) => {
    return AxiosInstance.post(`/brain/single-run/account-creative-profile`, { startDate, endDate, adAccount })
}

export const generateOverviewInsight = async ({ startDate, endDate, adAccount, type }) => {
    return AxiosInstance.post(`/brain/single-run/overview-insight`, { startDate, endDate, adAccount, type })
}

export const generateCreativeInsightLight = async ({ creativeId, startDate, endDate, adAccount }) => {
    return AxiosInstance.post(`/brain/single-run/creative-insight-light`, { creativeId, startDate, endDate, adAccount })
}

export const generateCreativeInsightFull = async ({ creativeId, startDate, endDate, adAccount }) => {
    return AxiosInstance.post(`/brain/single-run/creative-insight-full`, { creativeId, startDate, endDate, adAccount })
}

// Brain v2 — the-core-grounded creative DNA (tags + analysis status)
export const generateCreativeInsightV2 = async ({ creativeId, regenerate = false }) => {
    return AxiosInstance.post(`/brain/v2/creative-insight`, { creativeId, regenerate })
}

// CreativeView Intelligence + Ideas tabs — v1-logic insights/ideas (shaped like the
// v2 cards). DNA tags still come from the v2 endpoints above; these are the AI
// insights + ideas, generated on tab visit from the v1 brain logic.
export const generateCreativeInsightCards = async ({ creativeId, adAccount, startDate, endDate, regenerate = false }) => {
    return AxiosInstance.post(`/brain/single-run/creative-insight-cards`, { creativeId, adAccount, startDate, endDate, regenerate })
}

export const generateCreativeIdeaCards = async ({ creativeId, adAccount, startDate, endDate, regenerate = false }) => {
    return AxiosInstance.post(`/brain/single-run/creative-ideas`, { creativeId, adAccount, startDate, endDate, regenerate })
}

export const getCreativeCoherenceV2 = async ({ creativeId }) => {
    return AxiosInstance.post(`/brain/v2/creative-coherence`, { creativeId })
}

export const getCreativeDnaStatuses = async ({ creativeIds }) => {
    return AxiosInstance.post(`/brain/v2/creative-dna/status`, { creativeIds })
}

// On-demand v2 analysis — POSTs to the CREATIVE service (never the-core directly).
export const triggerCreativeAnalysis = async ({ creativeId }) => {
    return AxiosInstance.post(`/creative/analyze-user-creative/trigger`, { creativeId })
}

export const generateStrategicInsights = async ({ startDate, endDate, adAccount }) => {
    return AxiosInstance.post(`/brain/single-run/strategic-insights`, { startDate, endDate, adAccount })
}


/***** Brain Ends *****/

/***** Web Quest Starts *****/
export const getPageByUrl = async (pageUrl) => {
    // return AxiosInstance.get(`/web-quest/page?pageUrl=${pageUrl}`) // OLD - using Apify
    return AxiosInstance.get(`/web-quest/facebook-page?pageUrl=${pageUrl}`)
}

export const getPageJob = async (pageId) => {
    return AxiosInstance.get(`/web-quest/job?pageId=${pageId}`)
}

export const triggerPublicAdsProcess = async (pageId) => {
    return AxiosInstance.get(`/web-quest/public-ads?pageId=${pageId}`)
}

export const getMetaVideo = async (videoUrl) => {
    return AxiosInstance.get(`/web-quest/video?videoUrl=${videoUrl}`)
}

// web-quest/facebook-page-url
export const getFacebookPageUrl = async (websiteUrl) => {
    return AxiosInstance.get(`/web-quest/facebook-page-url?websiteUrl=${websiteUrl}`)
}

export const searchMetaAdvertiserByKeyword = async (keyword) => {
    return AxiosInstance.get(`/web-quest/meta-ads/search-advertiser?keyword=${keyword}`)
}

export const refreshAdvertiserCoverPhoto = async (advertiserId) => {
    return AxiosInstance.post(`/web-quest/advertiser/${advertiserId}/cover`)
}

/***** Web Quest Ends *****/

/***** Payments *****/
export const getPlans = async () => {
    return AxiosInstance.get(`/payments/plan`)
}

export const getSubscriptionOfAccount = async () => {
    return AxiosInstance.get(`payments/subscription/account`)
}

export const getEntitlementsOfAccount = async () => {
    return AxiosInstance.get(`payments/subscription/account/entitlements`)
}

export const cancelSubscription = async (subscriptionId) => {
    return AxiosInstance.post(`payments/subscription/cancel`, { subscriptionId })
}

export const upgradeSubscription = async ({ newPlanId, billingCycle, sessionId }) => {
    return AxiosInstance.post(`payments/subscription/upgrade`, { newPlanId, billingCycle, sessionId })
}

export const initShopifyCheckout = async ({ planId, callbackUrl, billingCycle }) => {
    return AxiosInstance.post(`payments/subscription/shopify/initialize-checkout`, { planId, callbackUrl, billingCycle })
}

export const verifyShopifyPayment = async (shopDomain) => {
    return AxiosInstance.get(`payments/subscription/shopify/verify-subscription?shopDomain=${shopDomain}`)
}

/***** Payments Ends *****/


/*****  the-core (v2 engine) Starts  *****/
export const listTheCoreAdvertisers = async () => {
    return AxiosInstance.get('/the-core/advertisers')
}

// Enriched vertical/category browse for the Advertisers page. Each row carries
// scale grades + a velocity series + top themes. Order is a seeded shuffle by
// default (randomized per visit, stable within a paging session).
// params: { vertical, category, geo, q, sort, seed, limit, offset }
export const browseTheCoreAdvertisers = async (params = {}, { signal } = {}) => {
    return AxiosInstance.get('/the-core/advertisers/browse', { params, signal })
}

// Vertical→category taxonomy (ids) for the Advertisers filter dropdowns.
export const getTheCoreTaxonomy = async (vertical) => {
    const params = {}
    if (vertical) {
        params.vertical = vertical
    }
    return AxiosInstance.get('/the-core/taxonomy', { params })
}

export const getTheCoreAdvertiser = async (advertiserId, { engagement } = {}) => {
    const params = {}
    if (engagement) {
        params.engagement = 1
    }
    return AxiosInstance.get(`/the-core/advertisers/${advertiserId}`, { params })
}

export const getTheCoreAd = async (adId, { engagement } = {}) => {
    const params = {}
    if (engagement) {
        params.engagement = 1
    }
    return AxiosInstance.get(`/the-core/ads/${adId}`, { params })
}

export const getTheCoreSimilarAds = async (adId) => {
    return AxiosInstance.get(`/the-core/ads/${adId}/similar`)
}

// Trigger the 14-pass analyze pipeline for a single ad on demand.
// Returns immediately (the engine runs the pipeline async); poll
// getTheCoreAd until passes.length > 0 to surface results.
export const analyzeTheCoreAd = async (adId) => {
    return AxiosInstance.post(`/the-core/ads/${adId}/analyze`)
}

export const onboardTheCoreBrand = async ({ facebookPageUrl, fbPageId, brandName, country, forceRefresh }) => {
    return AxiosInstance.post('/the-core/onboard-brand', {
        facebook_page_url: facebookPageUrl,
        fb_page_id: fbPageId,
        brand_name: brandName,
        country,
        force_refresh: forceRefresh,
    })
}

export const getTheCoreOnboardingJob = async (jobId) => {
    return AxiosInstance.get(`/the-core/onboarding-jobs/${jobId}`)
}

export const searchTheCoreBrands = async (q, { signal, country } = {}) => {
    const params = { q }
    if (country) {
        params.country = country
    }
    return AxiosInstance.get('/the-core/brand-search', { params, signal })
}

// DB-only typeahead — fast (no RapidAPI hop). Returns top 3 existing
// advertisers matching `q` via unaccent + ILIKE. Used by the Add advertiser
// dialog to render fast-path suggestions while the slower Meta typeahead
// resolves in parallel.
export const searchTheCoreExistingBrands = async (q, { signal } = {}) => {
    return AxiosInstance.get('/the-core/brand-search-existing', { params: { q }, signal })
}

/**
 * Discovery feed — ad-level browsing across the entire corpus.
 * Returns { ads, next_cursor }. Each ad carries inline brand context
 * (display_name + profile_picture_gcs + vertical) so the feed renders
 * without N+1 brand lookups.
 *
 * Filters:
 *   - vertical:         single vertical id from the closed enum (or null = all)
 *   - vertical_category: optional sub-bucket within the vertical
 *   - format:           'image' | 'video' | 'carousel' (or null = all)
 *   - funnel_stage:     'awareness' | 'consideration' | 'conversion' | 'retention'
 *   - q:                free-text search across descriptor_one_line + body
 *   - cursor:           opaque cursor from the previous page's next_cursor
 *   - limit:            page size (default 60)
 *
 * NOTE: the backend endpoint /the-core/ad-feed isn't built yet. Until
 * it lands this returns an empty page so the UI renders its empty state.
 */
export const searchTheCoreDiscovery = async (filters = {}, { signal } = {}) => {
    return AxiosInstance.get('/the-core/ad-feed', { params: filters, signal })
}

// Discovery "For you" overview: { vertical, category, view, funnel }.
export const getTheCoreDiscoveryOverview = async (params = {}, { signal } = {}) => {
    return AxiosInstance.get('/the-core/discovery/overview', { params, signal })
}

// Discovery feed page: { vertical, category, view, funnel, tile, offset, limit }.
export const getTheCoreDiscoveryFeed = async (params = {}, { signal } = {}) => {
    return AxiosInstance.get('/the-core/discovery/feed', { params, signal })
}

// Landing pages library: cursor-paged list and single-page detail.
export const listTheCoreLandingPages = async (params = {}, { signal } = {}) => {
    return AxiosInstance.get('/the-core/landing-pages', { params, signal })
}

export const getTheCoreLandingPage = async (pageId, { signal } = {}) => {
    return AxiosInstance.get(`/the-core/landing-pages/${encodeURIComponent(pageId)}`, { signal })
}

// Cached server-side. Returns funnel_stages + statuses + recencies + hooks +
// personas + angles + concepts (with counts) for the Library filter dropdowns.
export const searchTheCoreDiscoveryFacets = async () => {
    return AxiosInstance.get('/the-core/ad-feed/facets')
}

// Random brand suggestions for the home page's "Advertiser Suggestions"
// widget. Forwards `vertical` + `limit` query params to the-core, which
// samples brands with analyzed ads (optionally scoped to a vertical).
// Caller dedups against the watch list locally.
export const searchTheCoreAdvertiserSuggestions = async (filters = {}) => {
    return AxiosInstance.get('/the-core/advertisers/suggestions', { params: filters })
}

// Batch card summaries for an explicit advertiser-id list — powers the
// Watching page's card grid (identity, media split, top creatives).
export const getTheCoreAdvertiserSummaries = async (advertiserIds) => {
    return AxiosInstance.post('/the-core/advertisers/summaries', { advertiser_ids: advertiserIds })
}

// Collaborator roster for one advertiser — creators/partner pages seen on
// their ads, each with a small ad gallery. Powers the brand Creators tab.
export const getTheCoreAdvertiserCreators = async (advertiserId) => {
    return AxiosInstance.get(`/the-core/advertisers/${advertiserId}/creators`)
}

// Reddit-reviews summary for one advertiser — status lifecycle +
// summary/themes/quotes/threads. Powers the brand Reddit tab.
export const getTheCoreAdvertiserReddit = async (advertiserId) => {
    return AxiosInstance.get(`/the-core/advertisers/${advertiserId}/reddit`)
}
export const refreshTheCoreAdvertiserReddit = async (advertiserId) => {
    return AxiosInstance.post(`/the-core/advertisers/${advertiserId}/reddit/refresh`)
}

// Watch list — space ↔ advertiser CRUD (lives in Mongo's advertiser_space
// collection; identified by the-core's advertiser_id / Facebook page id).
export const listWatchedBrands = async () => {
    return AxiosInstance.get('/intelligence/watch-list')
}
export const watchBrand = async (advertiserId) => {
    return AxiosInstance.post('/intelligence/watch-list', { advertiser_id: advertiserId })
}
export const unwatchBrand = async (advertiserId) => {
    return AxiosInstance.delete(`/intelligence/watch-list/${advertiserId}`)
}

// Intelligence boards — per-space board CRUD + ad-membership.
// Server stores the-core ad IDs as strings in `boards.theCoreAdIds`.
export const listIntelligenceBoards = async () => {
    return AxiosInstance.get('/intelligence/boards')
}
export const getIntelligenceBoard = async (boardId) => {
    return AxiosInstance.get(`/intelligence/boards/${boardId}`)
}
export const createIntelligenceBoard = async ({ name, description }) => {
    return AxiosInstance.post('/intelligence/boards', { name, description })
}
export const deleteIntelligenceBoard = async (boardId) => {
    return AxiosInstance.delete(`/intelligence/boards/${boardId}`)
}
export const setAdIntelligenceBoards = async (adId, boardIds) => {
    return AxiosInstance.put(`/intelligence/ads/${adId}/boards`, { board_ids: boardIds })
}
export const setLandingPageIntelligenceBoards = async (pageId, boardIds) => {
    return AxiosInstance.put(`/intelligence/landing-pages/${encodeURIComponent(pageId)}/boards`, { board_ids: boardIds })
}

// Unauthenticated read of a shareable intelligence board. Backend resolves
// by board id only — no space/account context. Per-ad data is fetched
// separately via getPublicIntelligenceAd.
export const getPublicIntelligenceBoard = async (boardId) => {
    return AxiosInstance.get(`/intelligence/boards/public/${boardId}`)
}

// Public surfaces — used by the share page (no auth) and by the
// authed-page Download button (works the same either way since it's a
// signed-URL endpoint).
export const getPublicIntelligenceAd = async (adId) => {
    return AxiosInstance.get(`/intelligence/ads/public/${adId}`)
}
export const getPublicIntelligenceAdSimilar = async (adId) => {
    return AxiosInstance.get(`/intelligence/ads/public/${adId}/similar`)
}
export const getIntelligenceAdDownloadLink = async (adId) => {
    return AxiosInstance.get(`/intelligence/ads/public/${adId}/download-link`)
}
/***** the-core Ends *****/


/*****  /lets-go conference demo  *****/

// GET /public/demo/curated — prioritized tech/B2B brand list with cover
// + profile images for the bottom marquee.
export const getCuratedDemoBrands = async () => {
    return AxiosInstance.get('/public/demo/curated')
}

// GET /public/demo/similar?advertiser_id=X — "more brands like this"
// strip below the ads on the results screen.
export const getSimilarDemoBrands = async (advertiserId) => {
    return AxiosInstance.get('/public/demo/similar', { params: { advertiser_id: advertiserId } })
}

// GET /public/demo/search — Meta typeahead (slow, 2-5s). Each candidate
// tagged already_analyzed so the picker can route instant vs live-analyze.
// Fired in parallel with searchExistingDemoBrands below.
//
// Default country is 'ALL' so we hit every Meta Ad Library region pool
// — much better hit rate at the booth (visitor might pick an Israeli /
// UK / EU brand, no reason to gate to US).
export const searchDemoBrands = async (query, country = 'ALL', opts = {}) => {
    return AxiosInstance.get('/public/demo/search', {
        params: { q: query, country },
        signal: opts.signal,
    })
}

// GET /public/demo/search-existing — DB-only fast path (~200ms). Returns
// brands we've already analyzed, matched by name. The picker fires this
// alongside searchDemoBrands so existing matches render instantly while
// the slower Meta typeahead loads.
export const searchExistingDemoBrands = async (query, opts = {}) => {
    return AxiosInstance.get('/public/demo/search-existing', {
        params: { q: query },
        signal: opts.signal,
    })
}

// POST /public/demo/analyze — synchronous quick-onboard. Up to ~40s for
// live-analyze brands; cache-hits return in ~1s. Set a generous timeout
// so the browser doesn't bail mid-flight.
export const analyzeDemoBrand = async ({ fb_page_id, facebook_page_url, country, lead_email }) => {
    return AxiosInstance.post(
        '/public/demo/analyze',
        { fb_page_id, facebook_page_url, country, lead_email },
        { timeout: 75000 },
    )
}

// POST /public/demo/lead — best-effort lead capture. Fire-and-await but
// non-blocking on errors; we never want a Mongo hiccup to stop a booth
// visitor from seeing the demo.
export const captureDemoLead = async ({ email, name, company, pickedBrandId, pickedBrandName }) => {
    return AxiosInstance.post('/public/demo/lead', { email, name, company, pickedBrandId, pickedBrandName })
}

// POST /public/demo/compare-lead — high-intent lead from the "Get my
// compare report" CTA on the results screen. Captures both advertisers
// (first auto-filled from the visitor's analysis, second free-typed).
export const submitCompareLead = async ({ email, firstAdvertiserName, firstAdvertiserId, secondAdvertiserName }) => {
    return AxiosInstance.post('/public/demo/compare-lead', {
        email,
        firstAdvertiserName,
        firstAdvertiserId,
        secondAdvertiserName,
    })
}


/*****  Developer / Public API Starts  *****/
// Account-scoped public-API key (one active key per account). All three are
// admin/owner-gated on the backend, so a lesser role gets a 403 — the key panel
// renders its locked state on that. The account is taken from the x-account-id
// header the Axios instance already sends.
export const getPublicApiKey = async () => {
    return AxiosInstance.get('/public-api/key')
}

export const generatePublicApiKey = async () => {
    return AxiosInstance.post('/public-api/key')
}

export const revokePublicApiKey = async () => {
    return AxiosInstance.delete('/public-api/key')
}

// Usage summary — { '7d'|'30d'|'90d': { totals, series, by_route } } for the
// account's keys. Member-readable (any active member), scoped by x-account-id.
export const getPublicApiUsage = async () => {
    return AxiosInstance.get('/public-api/usage')
}

// Shadow credit balance this month (API + MCP) — { used, grant, remaining,
// resets_on, by_bucket, by_surface, ... }. Display-only, member-readable.
export const getPublicApiCredits = async () => {
    return AxiosInstance.get('/public-api/credits')
}
/*****  Developer / Public API Ends  *****/

